<template>
    <div class="default-wrap ledger-total">
        <div class="list">
            <div class="item income">
                <div class="title">
                    記帳收入
                    <span class="total">
                        {{incomeTotal.total}} 筆
                    </span>
                </div>
                <div class="content blue">
                    <span v-if="!isPositive(incomeTotal.amount)">-</span>
                    {{toCurrency(incomeTotal.amount)}}
                </div>
            </div>
            <div class="item">
                <div class="title">
                    記帳支出
                    <span class="total">
                        {{expenseTotal.total}} 筆
                    </span>
                </div>
                <div class="content red">
                    <span v-if="!isPositive(expenseTotal.amount)">-</span>
                    {{toCurrency(expenseTotal.amount)}}
                </div>
            </div>
            <div class="item">
                <div class="title">
                    代墊收益
                    <span class="total">
                        {{advancePaymentTotal.total}} 筆
                    </span>
                </div>
                <div class="content">
                    <span v-if="!isPositive(advancePaymentTotal.amount)">-</span>
                    {{toCurrency(Math.abs(advancePaymentTotal.amount))}}
                </div>
            </div>
            <div class="item all">
                <div class="title">
                    收支合計
                    <word-tips-hover data="收支合計：記帳收入 + 代墊 - 記帳支出" width="280px" left="-100px"></word-tips-hover>
                </div>
                <div class="content" :class="{'blue': isPositive(ledgerTotalAmount), 'red': !isPositive(ledgerTotalAmount)}">
                    <span v-if="!isPositive(ledgerTotalAmount)">-</span>
                    {{toCurrency(Math.abs(ledgerTotalAmount))}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import wordTipsHover from '@/components/bussiness/widges/tips/wordTipsHover.vue';
import { mapGetters } from 'vuex'
export default {
    methods: {
        isPositive: function (value) {
            if(value){
                let result = Math.sign(value)
                if( result == 1 || result == 0){
                    return true
                }else{
                    return false
                }
            }else{
                return true
            }
        }
    },
    computed: {
        // advancePaymentTotalAmountIsPositive: function () {
        //     return this.isPositive(this.advancePaymentTotal)
        // },
        // ledgerTotalAmountIsPositive: function () {
        //     return this.isPositive(this.ledgerTotalAmount)
        // },
        ledgerTotalAmount: function () {
            return this.incomeTotal.amount-this.expenseTotal.amount+this.advancePaymentTotal.amount
        },
        ...mapGetters({
            incomeTotal: 'GET_BIZ_LEDGER_MGT_INCOME_TOTAL',
            expenseTotal: 'GET_BIZ_LEDGER_MGT_EXPENSE_TOTAL',
            advancePaymentTotal: 'GET_BIZ_LEDGER_MGT_ADVANCE_PAYMENT_TOTAL'
        })
    },
    components: {
        wordTipsHover
    }
}
</script>

<style lang="scss" scoped>
.ledger-total{
    position: relative;
    margin-bottom: 20px;
    .list{
        display: flex;
        align-items: center;
        .item{
            position: relative;
            margin: 0 70px;
            &:after{
                content: '';
                position: absolute;
                width: 1px;
                height: 57px;
                background: #f3f3f3;
                top: 0;
                right: -70px;
            }
            &.income{
                margin-left: 55px;
            }
            &.all{
                margin-left: 120px;
                margin-right: 0px;
                &:after{
                    display: none;
                }
            }
            .title{
                display: flex;
                font-size: 16px;
                margin-bottom: 12px;
                .total{
                    font-size: 12px;
                    padding: 4px 8px;
                    margin-left: 6px;
                    border-radius: 2px;
                    background-color: #f6f6f6;
                }
            }
            .content{
                font-size: 20px;
                font-weight: 500;
                &.blue{
                    color: #3942b5;
                }
                &.red{
                    color: #fc7171;
                }
            }
        }
    }
    
}
</style>


// WEBPACK FOOTER //
// src/components/bussiness/financialReport/ledgerMgt/ledgerTotal.vue